import { environment } from 'src/environments/environment';

const councilData = {
  '2025-2026': [
  {
     id: '274',
     district: '83',
     name: 'Immacolata Youngstown',
     location: 'Youngstown',
     diocese: '6',
     division: '2'
  },
  {
     id: '310',
     district: '33',
     name: 'Gilmour',
     location: 'Mayfield Heights',
     diocese: '2',
     division: '1'
  },
  {
     id: '341',
     district: '74',
     name: 'Canton',
     location: 'Canton',
     diocese: '6',
     division: '2'
  },
  {
     id: '360',
     district: '71',
     name: 'Ashtabula',
     location: 'Ashtabula',
     diocese: '6',
     division: '2'
  },
  {
     id: '386',
     district: '68',
     name: 'Monsignor O\'Connell',
     location: 'Toledo',
     diocese: '5',
     division: '4'
  },
  {
     id: '400',
     district: '47',
     name: 'Columbus',
     location: 'Columbus',
     diocese: '3',
     division: ''
  },
  {
     id: '472',
     district: '50',
     name: 'Immaculate Heart of Mary',
     location: 'Steubenville',
     diocese: '4',
     division: '2'
  },
  {
     id: '478',
     district: '53',
     name: 'Marietta',
     location: 'Marietta',
     diocese: '4',
     division: '1'
  },
  {
     id: '500',
     district: '7',
     name: 'Dayton',
     location: 'Dayton',
     diocese: '1',
     division: '1'
  },
  {
     id: '505',
     district: '41',
     name: 'Monsignor Linus J Dury',
     location: 'Zanesville',
     diocese: '3',
     division: '1'
  },
  {
     id: '507',
     district: '77',
     name: 'Holy Trinity',
     location: 'Wellsville',
     diocese: '6',
     division: '4'
  },
  {
     id: '509',
     district: '99',
     name: 'Carroll',
     location: 'East Liverpool',
     diocese: '6',
     division: ''
  },
  {
     id: '546',
     district: '64',
     name: 'Sandusky',
     location: 'Sandusky',
     diocese: '5',
     division: '1'
  },
  {
     id: '547',
     district: '30',
     name: 'Akron',
     location: 'Akron',
     diocese: '2',
     division: '5'
  },
  {
     id: '554',
     district: '73',
     name: 'Massillon',
     location: 'Massillon',
     diocese: '6',
     division: '1'
  },
  {
     id: '558',
     district: '72',
     name: 'Alliance',
     location: 'Alliance',
     diocese: '6',
     division: '2'
  },
  {
     id: '576',
     district: '34',
     name: 'Dennison',
     location: 'Dennison',
     diocese: '3',
     division: '2'
  },
  {
     id: '591',
     district: '64',
     name: 'Fremont',
     location: 'Fremont',
     diocese: '5',
     division: '1'
  },
  {
     id: '608',
     district: '69',
     name: 'Tiffin',
     location: 'Tiffin',
     diocese: '5',
     division: '1'
  },
  {
     id: '620',
     district: '79',
     name: 'Warren',
     location: 'Warren',
     diocese: '6',
     division: ''
  },
  {
     id: '624',
     district: '4',
     name: 'Springfield',
     location: 'Springfield',
     diocese: '1',
     division: '1'
  },
  {
     id: '626',
     district: '65',
     name: 'Norwalk',
     location: 'Norwalk',
     diocese: '5',
     division: '1'
  },
  {
     id: '627',
     district: '84',
     name: 'Conneaut',
     location: 'Conneaut',
     diocese: '6',
     division: ''
  },
  {
     id: '637',
     district: '20',
     name: 'Lorain',
     location: 'Lorain',
     diocese: '2',
     division: '1'
  },
  {
     id: '659',
     district: '2',
     name: 'Sidney',
     location: 'Sidney',
     diocese: '1',
     division: '1'
  },
  {
     id: '671',
     district: '45',
     name: 'Father William J Spickerman',
     location: 'Marion',
     diocese: '3',
     division: '1'
  },
  {
     id: '687',
     district: '67',
     name: 'Mansfield',
     location: 'Mansfield',
     diocese: '5',
     division: '2'
  },
  {
     id: '711',
     district: '66',
     name: 'Holy Trinity',
     location: 'Bucyrus',
     diocese: '5',
     division: '3'
  },
  {
     id: '721',
     district: '43',
     name: 'Newark',
     location: 'Newark',
     diocese: '3',
     division: '3'
  },
  {
     id: '733',
     district: '22',
     name: 'Cleveland',
     location: 'Cleveland',
     diocese: '2',
     division: '4'
  },
  {
     id: '741',
     district: '38',
     name: 'Portsmouth',
     location: 'Portsmouth',
     diocese: '3',
     division: '1'
  },
  {
     id: '752',
     district: '70',
     name: 'Bellevue',
     location: 'Bellevue',
     diocese: '5',
     division: '4'
  },
  {
     id: '774',
     district: '20',
     name: 'Elyria',
     location: 'Elyria',
     diocese: '2',
     division: '1'
  },
  {
     id: '789',
     district: '32',
     name: 'Wooster',
     location: 'Wooster',
     diocese: '2',
     division: '3'
  },
  {
     id: '847',
     district: '43',
     name: 'Mt Vernon',
     location: 'Mt Vernon',
     diocese: '3',
     division: '3'
  },
  {
     id: '885',
     district: '66',
     name: 'Rosecrans',
     location: 'Willard',
     diocese: '5',
     division: '3'
  },
  {
     id: '910',
     district: '43',
     name: 'St Lukes',
     location: 'Danville',
     diocese: '3',
     division: '2'
  },
  {
     id: '947',
     district: '23',
     name: 'Painesville',
     location: 'Painesville',
     diocese: '2',
     division: '2'
  },
  {
     id: '957',
     district: '69',
     name: 'Leo',
     location: 'Findlay',
     diocese: '5',
     division: '1'
  },
  {
     id: '968',
     district: '11',
     name: 'Father Butler',
     location: 'Hamilton',
     diocese: '1',
     division: '1'
  },
  {
     id: '994',
     district: '34',
     name: 'Coshocton',
     location: 'Coshocton',
     diocese: '3',
     division: '4'
  },
  {
     id: '1016',
     district: '39',
     name: 'Lancaster',
     location: 'Lancaster',
     diocese: '3',
     division: '1'
  },
  {
     id: '1039',
     district: '60',
     name: 'Monsignor Lang',
     location: 'Defiance',
     diocese: '5',
     division: '1'
  },
  {
     id: '1056',
     district: '45',
     name: 'Delaware',
     location: 'Delaware',
     diocese: '3',
     division: '1'
  },
  {
     id: '1065',
     district: '41',
     name: 'Macgahan',
     location: 'New Lexington',
     diocese: '3',
     division: '3'
  },
  {
     id: '1071',
     district: '38',
     name: 'Flaget',
     location: 'Chillicothe',
     diocese: '3',
     division: '3'
  },
  {
     id: '1117',
     district: '65',
     name: 'St John Neumann',
     location: 'Monroeville',
     diocese: '5',
     division: '4'
  },
  {
     id: '1162',
     district: '15',
     name: 'Norwood',
     location: 'Norwood',
     diocese: '1',
     division: '3'
  },
  {
     id: '1175',
     district: '70',
     name: 'Clyde',
     location: 'Clyde',
     diocese: '5',
     division: '4'
  },
  {
     id: '1195',
     district: '14',
     name: 'Archbishop Elder',
     location: 'Cincinnati',
     diocese: '1',
     division: '1'
  },
  {
     id: '1197',
     district: '69',
     name: 'Fostoria',
     location: 'Fostoria',
     diocese: '5',
     division: '1'
  },
  {
     id: '1234',
     district: '67',
     name: 'St Francis',
     location: 'Galion',
     diocese: '5',
     division: '3'
  },
  {
     id: '1246',
     district: '52',
     name: 'Bellaire',
     location: 'Bellaire',
     diocese: '4',
     division: '3'
  },
  {
     id: '1272',
     district: '2',
     name: 'Wapakoneta',
     location: 'Wapakoneta',
     diocese: '1',
     division: '1'
  },
  {
     id: '1341',
     district: '38',
     name: 'Discovery',
     location: 'Wellston',
     diocese: '3',
     division: '5'
  },
  {
     id: '1344',
     district: '57',
     name: 'Napoleon',
     location: 'Napoleon',
     diocese: '5',
     division: '3'
  },
  {
     id: '1362',
     district: '62',
     name: 'Ray McKowen',
     location: 'Delphos',
     diocese: '5',
     division: '1'
  },
  {
     id: '1405',
     district: '38',
     name: 'Watterson',
     location: 'Ironton',
     diocese: '3',
     division: '2'
  },
  {
     id: '1411',
     district: '75',
     name: 'Kent',
     location: 'Kent',
     diocese: '6',
     division: '3'
  },
  {
     id: '1417',
     district: '75',
     name: 'Immaculate Conception',
     location: 'Ravenna',
     diocese: '6',
     division: '5'
  },
  {
     id: '1421',
     district: '51',
     name: 'Mother of God',
     location: 'Martins Ferry',
     diocese: '4',
     division: '4'
  },
  {
     id: '1494',
     district: '56',
     name: 'Edgerton',
     location: 'Edgerton',
     diocese: '5',
     division: '2'
  },
  {
     id: '1569',
     district: '77',
     name: 'Leetonia',
     location: 'Leetonia',
     diocese: '6',
     division: '3'
  },
  {
     id: '1592',
     district: '1',
     name: 'Father James O Byrne',
     location: 'St Marys',
     diocese: '1',
     division: '1'
  },
  {
     id: '1597',
     district: '45',
     name: 'Kenton',
     location: 'Kenton',
     diocese: '3',
     division: '5'
  },
  {
     id: '1610',
     district: '10',
     name: 'St John Paul Ii',
     location: 'Middletown',
     diocese: '1',
     division: '1'
  },
  {
     id: '1617',
     district: '28',
     name: 'Barberton',
     location: 'Barberton',
     diocese: '2',
     division: '3'
  },
  {
     id: '1641',
     district: '53',
     name: 'Cambridge',
     location: 'Cambridge',
     diocese: '4',
     division: '4'
  },
  {
     id: '1664',
     district: '54',
     name: 'Msgr John Joseph Jessing',
     location: 'Pomeroy',
     diocese: '4',
     division: '5'
  },
  {
     id: '1681',
     district: '80',
     name: 'Niles',
     location: 'Niles',
     diocese: '6',
     division: '4'
  },
  {
     id: '1683',
     district: '13',
     name: 'Northside',
     location: 'Cincinnati',
     diocese: '1',
     division: '1'
  },
  {
     id: '1716',
     district: '54',
     name: 'Father Frank Patala',
     location: 'Athens',
     diocese: '4',
     division: '3'
  },
  {
     id: '1718',
     district: '66',
     name: 'New Washington',
     location: 'New Washington',
     diocese: '5',
     division: '1'
  },
  {
     id: '1727',
     district: '4',
     name: 'Urbana',
     location: 'Urbana',
     diocese: '1',
     division: '2'
  },
  {
     id: '1747',
     district: '12',
     name: 'St Patrick',
     location: 'Carthage Cin',
     diocese: '1',
     division: '1'
  },
  {
     id: '1750',
     district: '64',
     name: 'Port Clinton',
     location: 'Port Clinton',
     diocese: '5',
     division: '2'
  },
  {
     id: '1756',
     district: '3',
     name: 'St Denis',
     location: 'Versailles',
     diocese: '1',
     division: '1'
  },
  {
     id: '1757',
     district: '63',
     name: 'Ottawa',
     location: 'Ottawa',
     diocese: '5',
     division: '1'
  },
  {
     id: '1782',
     district: '4',
     name: 'Bellefontaine',
     location: 'Bellefontaine',
     diocese: '1',
     division: '4'
  },
  {
     id: '1786',
     district: '35',
     name: 'Father Reidy',
     location: 'London',
     diocese: '3',
     division: '4'
  },
  {
     id: '1796',
     district: '3',
     name: 'Greenville',
     location: 'Greenville',
     diocese: '1',
     division: '2'
  },
  {
     id: '1800',
     district: '1',
     name: 'Celina',
     location: 'Celina',
     diocese: '1',
     division: '1'
  },
  {
     id: '1801',
     district: '5',
     name: 'Father Alphonse Schumacher',
     location: 'Xenia',
     diocese: '1',
     division: '2'
  },
  {
     id: '1818',
     district: '78',
     name: 'Salem',
     location: 'Salem',
     diocese: '6',
     division: '4'
  },
  {
     id: '1890',
     district: '78',
     name: 'Reagan',
     location: 'East Palestine',
     diocese: '6',
     division: '5'
  },
  {
     id: '1915',
     district: '56',
     name: 'Bryan',
     location: 'Bryan',
     diocese: '5',
     division: '3'
  },
  {
     id: '1925',
     district: '69',
     name: 'Carey',
     location: 'Carey',
     diocese: '5',
     division: '3'
  },
  {
     id: '1944',
     district: '64',
     name: 'Oak Harbor',
     location: 'Oak Harbor',
     diocese: '5',
     division: '5'
  },
  {
     id: '1968',
     district: '66',
     name: 'Father Michael McFadden',
     location: 'Shelby',
     diocese: '5',
     division: '1'
  },
  {
     id: '1973',
     district: '34',
     name: 'Dover',
     location: 'Dover',
     diocese: '3',
     division: '1'
  },
  {
     id: '1991',
     district: '1',
     name: 'Coldwater',
     location: 'Coldwater',
     diocese: '1',
     division: '1'
  },
  {
     id: '2039',
     district: '75',
     name: 'St Joseph',
     location: 'Randolph',
     diocese: '6',
     division: '2'
  },
  {
     id: '2050',
     district: '69',
     name: 'Upper Sandusky',
     location: 'Upper Sandusky',
     diocese: '5',
     division: '1'
  },
  {
     id: '2072',
     district: '84',
     name: 'Msgr Francis J Hughes',
     location: 'Hubbard',
     diocese: '6',
     division: '3'
  },
  {
     id: '2158',
     district: '2',
     name: 'Fr Andrew Kunkler',
     location: 'Minster',
     diocese: '1',
     division: '1'
  },
  {
     id: '2187',
     district: '55',
     name: 'Toronto',
     location: 'Toronto',
     diocese: '4',
     division: ''
  },
  {
     id: '2238',
     district: '63',
     name: 'Ottoville',
     location: 'Ottoville',
     diocese: '5',
     division: '3'
  },
  {
     id: '2262',
     district: '55',
     name: 'St Anthony',
     location: 'Bridgeport',
     diocese: '4',
     division: '5'
  },
  {
     id: '2280',
     district: '70',
     name: 'Gibsonburg',
     location: 'Gibsonburg',
     diocese: '5',
     division: '3'
  },
  {
     id: '2299',
     district: '39',
     name: 'St James',
     location: 'Logan',
     diocese: '3',
     division: '3'
  },
  {
     id: '2362',
     district: '25',
     name: 'Cuyahoga Falls',
     location: 'Cuyahoga Falls',
     diocese: '2',
     division: '2'
  },
  {
     id: '2372',
     district: '34',
     name: 'Lcpl. Peter Clore',
     location: 'New Philadelphia',
     diocese: '3',
     division: '4'
  },
  {
     id: '2374',
     district: '16',
     name: 'Ripley',
     location: 'Ripley',
     diocese: '1',
     division: '3'
  },
  {
     id: '2423',
     district: '16',
     name: 'Father Sourd',
     location: 'Fayetteville',
     diocese: '1',
     division: '2'
  },
  {
     id: '2530',
     district: '72',
     name: 'Louisville',
     location: 'Louisville',
     diocese: '6',
     division: '4'
  },
  {
     id: '2565',
     district: '53',
     name: 'Father Klueber',
     location: 'Caldwell',
     diocese: '4',
     division: '3'
  },
  {
     id: '2584',
     district: '62',
     name: 'St Josephs',
     location: 'Paulding',
     diocese: '5',
     division: '2'
  },
  {
     id: '2633',
     district: '13',
     name: 'Harrison',
     location: 'Harrison',
     diocese: '1',
     division: '1'
  },
  {
     id: '2640',
     district: '1',
     name: 'St Henry',
     location: 'St Henry',
     diocese: '1',
     division: '1'
  },
  {
     id: '2642',
     district: '67',
     name: 'Monsignor Leo W Frye',
     location: 'Crestline',
     diocese: '5',
     division: '5'
  },
  {
     id: '2643',
     district: '22',
     name: 'Lakewood',
     location: 'Lakewood',
     diocese: '2',
     division: '4'
  },
  {
     id: '2661',
     district: '60',
     name: 'Loyalty',
     location: 'Lima',
     diocese: '5',
     division: ''
  },
  {
     id: '2668',
     district: '29',
     name: 'Berea',
     location: 'Berea',
     diocese: '2',
     division: ''
  },
  {
     id: '2726',
     district: '33',
     name: 'Windermere',
     location: 'East Cleveland',
     diocese: '2',
     division: '3'
  },
  {
     id: '2786',
     district: '28',
     name: 'Northeast',
     location: 'Cleveland',
     diocese: '2',
     division: ''
  },
  {
     id: '2790',
     district: '22',
     name: 'West Park',
     location: 'Cleveland',
     diocese: '2',
     division: '2'
  },
  {
     id: '2798',
     district: '17',
     name: 'Purcell',
     location: 'Cincinnati',
     diocese: '1',
     division: '1'
  },
  {
     id: '2803',
     district: '31',
     name: 'Brooklyn-Parma',
     location: 'Cleveland',
     diocese: '2',
     division: '2'
  },
  {
     id: '2816',
     district: '28',
     name: 'Newburg',
     location: 'Cleveland',
     diocese: '2',
     division: ''
  },
  {
     id: '2850',
     district: '57',
     name: 'Sacred Heart',
     location: 'Swanton',
     diocese: '5',
     division: '3'
  },
  {
     id: '2886',
     district: '27',
     name: 'Willoughby',
     location: 'Willoughby',
     diocese: '2',
     division: '4'
  },
  {
     id: '2898',
     district: '37',
     name: 'Santa Maria',
     location: 'Columbus',
     diocese: '3',
     division: '4'
  },
  {
     id: '2927',
     district: '15',
     name: 'Bishop Fenwick',
     location: 'Cincinnati',
     diocese: '1',
     division: '3'
  },
  {
     id: '2935',
     district: '83',
     name: 'Girard',
     location: 'Girard',
     diocese: '6',
     division: '2'
  },
  {
     id: '3046',
     district: '29',
     name: 'Fairview',
     location: 'Fairview Park',
     diocese: '2',
     division: ''
  },
  {
     id: '3062',
     district: '66',
     name: 'Seven Saints',
     location: 'Attica',
     diocese: '5',
     division: '2'
  },
  {
     id: '3069',
     district: '28',
	 name: 'Archbishop Hallinan',
     location: 'Cleveland',
     diocese: '2',
     division: ''
  },
  {
     id: '3087',
     district: '28',
     name: 'Heights',
     location: 'Cleveland',
     diocese: '2',
     division: ''
  },
  {
     id: '3122',
     district: '59',
     name: 'West Toledo',
     location: 'Toledo',
     diocese: '5',
     division: '1'
  },
  {
     id: '3123',
     district: '14',
     name: 'Msgr Gerdes',
     location: 'Cincinnati',
     diocese: '1',
     division: '2'
  },
  {
     id: '3126',
     district: '29',
     name: 'Bishop Hagan',
     location: 'Cleveland',
     diocese: '2',
     division: ''
  },
  {
     id: '3144',
     district: '99',
     name: 'Fr Joseph Gallagher',
     location: 'Youngstown',
     diocese: '6',
     division: ''
  },
  {
     id: '3164',
     district: '27',
     name: 'Euclid',
     location: 'Euclid',
     diocese: '2',
     division: '3'
  },
  {
     id: '3213',
     district: '19',
     name: 'Father Carl Anthony',
     location: 'Wadsworth',
     diocese: '2',
     division: '2'
  },
  {
     id: '3222',
     district: '29',
     name: 'Southeast',
     location: 'Cleveland',
     diocese: '2',
     division: ''
  },
  {
     id: '3269',
     district: '20',
     name: 'Father Ragan',
     location: 'Avon & Avon Lake',
     diocese: '2',
     division: '1'
  },
  {
     id: '3297',
     district: '29',
     name: 'Brookside',
     location: 'Cleveland',
     diocese: '2',
     division: ''
  },
  {
     id: '3304',
     district: '23',
     name: 'Geauga',
     location: 'Chardon',
     diocese: '2',
     division: '2'
  },
  {
     id: '3324',
     district: '1',
     name: 'Fort Recovery',
     location: 'Fort Recovery',
     diocese: '1',
     division: '1'
  },
  {
     id: '3335',
     district: '54',
     name: 'St Louis IX',
     location: 'Gallipolis',
     diocese: '4',
     division: '5'
  },
  {
     id: '3344',
     district: '6',
     name: 'Archbishop McNicholas',
     location: 'Piqua',
     diocese: '1',
     division: '1'
  },
  {
     id: '3350',
     district: '84',
     name: 'Newton Falls',
     location: 'Newton Falls',
     diocese: '6',
     division: ''
  },
  {
     id: '3369',
     district: '9',
     name: 'Father O\' Donoghue',
     location: 'Wilmington',
     diocese: '1',
     division: '4'
  },
  {
     id: '3376',
     district: '17',
     name: 'Mother Seton',
     location: 'Cincinnati',
     diocese: '1',
     division: '3'
  },
  {
     id: '3382',
     district: '12',
     name: 'St Michael',
     location: 'Cincinnati',
     diocese: '1',
     division: '4'
  },
  {
     id: '3410',
     district: '19',
     name: 'South Akron',
     location: 'Akron',
     diocese: '2',
     division: '1'
  },
  {
     id: '3529',
     district: '25',
     name: 'Akron Northeast',
     location: 'Northeast Akron',
     diocese: '2',
     division: '3'
  },
  {
     id: '3541',
     district: '32',
     name: 'Father Mahan',
     location: 'Ashland',
     diocese: '2',
     division: '5'
  },
  {
     id: '3564',
     district: '60',
     name: 'Our Lady of Fatima',
     location: 'Toledo',
     diocese: '5',
     division: ''
  },
  {
     id: '3617',
     district: '62',
     name: 'Infant of Prague',
     location: 'Payne',
     diocese: '5',
     division: '5'
  },
  {
     id: '3698',
     district: '7',
     name: 'Eaton',
     location: 'Eaton',
     diocese: '1',
     division: '4'
  },
  {
     id: '3724',
     district: '5',
     name: 'Fairborn',
     location: 'Fairborn',
     diocese: '1',
     division: '1'
  },
  {
     id: '3727',
     district: '46',
     name: 'Assumption',
     location: 'Columbus',
     diocese: '3',
     division: '3'
  },
  {
     id: '3730',
     district: '5',
     name: 'Fr William O Connor',
     location: 'Dayton',
     diocese: '1',
     division: '2'
  },
  {
     id: '3737',
     district: '18',
     name: 'Our Lady of Mercy',
     location: 'Springfield',
     diocese: '1',
     division: ''
  },
  {
     id: '3754',
     district: '7',
     name: 'Marian',
     location: 'Dayton',
     diocese: '1',
     division: '2'
  },
  {
     id: '3766',
     district: '76',
     name: 'Mantua',
     location: 'Mantua',
     diocese: '6',
     division: '3'
  },
  {
     id: '3767',
     district: '28',
     name: 'Immaculata',
     location: ' ',
     diocese: '2',
     division: ''
  },
  {
     id: '3777',
     district: '72',
     name: 'Bishop Mcfadden',
     location: 'North Canton',
     diocese: '6',
     division: '2'
  },
  {
     id: '3813',
     district: '83',
     name: 'Marian',
     location: 'Campbell',
     diocese: '6',
     division: '5'
  },
  {
     id: '3822',
     district: '28',
     name: 'Pius X',
     location: 'Parma',
     diocese: '2',
     division: ''
  },
  {
     id: '3861',
     district: '14',
     name: 'Abp Moeller',
     location: 'Cincinnati',
     diocese: '1',
     division: '2'
  },
  {
     id: '3864',
     district: '44',
     name: 'Marian',
     location: 'Columbus',
     diocese: '3',
     division: '3'
  },
  {
     id: '3873',
     district: '6',
     name: 'Fr W Howard Bishop',
     location: 'Troy',
     diocese: '1',
     division: '3'
  },
  {
     id: '3883',
     district: '56',
     name: 'Fr De Veaux',
     location: 'Blakeslee',
     diocese: '5',
     division: '3'
  },
  {
     id: '3890',
     district: '3',
     name: 'St Remy',
     location: 'Russia',
     diocese: '1',
     division: '2'
  },
  {
     id: '3891',
     district: '13',
     name: 'Madonna',
     location: 'Cincinnati',
     diocese: '1',
     division: '3'
  },
  {
     id: '3904',
     district: '58',
     name: 'St Jude',
     location: 'So Toledo',
     diocese: '5',
     division: '4'
  },
  {
     id: '3930',
     district: '82',
     name: 'Msgr Mears',
     location: 'Austintown',
     diocese: '6',
     division: '3'
  },
  {
     id: '3970',
     district: '26',
     name: 'Lafayette',
     location: 'Independence',
     diocese: '2',
     division: '4'
  },
  {
     id: '3984',
     district: '99',
     name: 'Masury',
     location: ' ',
     diocese: '6',
     division: ''
  },
  {
     id: '4022',
     district: '8',
     name: 'Maria-Joseph',
     location: 'Dayton',
     diocese: '1',
     division: '3'
  },
  {
     id: '4028',
     district: '28',
     name: 'Cardinal Mindszenty-Fr Paul Haren',
     location: 'Barberton',
     diocese: '2',
     division: ''
  },
  {
     id: '4049',
     district: '77',
     name: 'Lisbon',
     location: 'Lisbon',
     diocese: '6',
     division: ''
  },
  {
     id: '4130',
     district: '31',
     name: 'Garfield Heights',
     location: 'Garfield Heights',
     diocese: '2',
     division: '1'
  },
  {
     id: '4168',
     district: '24',
     name: 'Medina',
     location: 'Medina',
     diocese: '2',
     division: '2'
  },
  {
     id: '4169',
     district: '68',
     name: 'St Lawrence',
     location: 'North Toledo',
     diocese: '5',
     division: '4'
  },
  {
     id: '4180',
     district: '47',
     name: 'Our Lady of the Rosary',
     location: 'Columbus',
     diocese: '3',
     division: ''
  },
  {
     id: '4212',
     district: '71',
     name: 'Jefferson',
     location: 'Jefferson',
     diocese: '6',
     division: '5'
  },
  {
     id: '4217',
     district: '22',
     name: 'Trinity',
     location: 'Cleveland',
     diocese: '2',
     division: '2'
  },
  {
     id: '4223',
     district: '29',
     name: 'Our Lady of The Lake',
     location: 'Lorain-Sheffield Lake',
     diocese: '2',
     division: ''
  },
  {
     id: '4224',
     district: '84',
     name: 'Struthers',
     location: 'Struthers',
     diocese: '6',
     division: ''
  },
  {
     id: '4237',
     district: '70',
     name: 'Genoa',
     location: 'Genoa',
     diocese: '5',
     division: '5'
  },
  {
     id: '4243',
     district: '52',
     name: 'Our Lady of Peace',
     location: 'St Clairsville',
     diocese: '4',
     division: '2'
  },
  {
     id: '4324',
     district: '47',
     name: 'Ascension',
     location: 'Johnstown',
     diocese: '3',
     division: '3'
  },
  {
     id: '4361',
     district: '51',
     name: 'Msgr Joseph F Dooley',
     location: 'Mingo Jct',
     diocese: '4',
     division: '2'
  },
  {
     id: '4378',
     district: '2',
     name: 'Father Anthony Wolf',
     location: 'Russells Point',
     diocese: '1',
     division: '3'
  },
  {
     id: '4424',
     district: '6',
     name: 'Our Lady of Peace',
     location: 'Huber Heights',
     diocese: '1',
     division: '2'
  },
  {
     id: '4433',
     district: '84',
     name: 'Windham',
     location: 'Windham',
     diocese: '6',
     division: ''
  },
  {
     id: '4437',
     district: '55',
     name: 'Pope Pius XII',
     location: 'Adena',
     diocese: '4',
     division: ''
  },
  {
     id: '4448',
     district: '67',
     name: 'Joseph Scholl',
     location: 'Mansfield',
     diocese: '5',
     division: '4'
  },
  {
     id: '4471',
     district: '81',
     name: 'Christ Our Savior',
     location: 'Struthers',
     diocese: '6',
     division: '2'
  },
  {
     id: '4484',
     district: '79',
     name: 'St Frances Xavier Cabrini',
     location: 'Warren',
     diocese: '6',
     division: '4'
  },
  {
     id: '4498',
     district: '27',
     name: 'Magnificat',
     location: 'Willowick',
     diocese: '2',
     division: '3'
  },
  {
     id: '4533',
     district: '74',
     name: 'Our Lady of Lourdes',
     location: 'Reedurban',
     diocese: '6',
     division: '2'
  },
  {
     id: '4539',
     district: '65',
     name: 'Vermilion',
     location: 'Vermilion',
     diocese: '5',
     division: '2'
  },
  {
     id: '4558',
     district: '18',
     name: 'St Christopher',
     location: 'Cincinnati',
     diocese: '1',
     division: ''
  },
  {
     id: '4571',
     district: '76',
     name: 'Msgr Lavelle',
     location: 'Streetsboro',
     diocese: '6',
     division: '3'
  },
  {
     id: '4587',
     district: '9',
     name: 'Saint Joseph',
     location: 'Miamisburg',
     diocese: '1',
     division: '3'
  },
  {
     id: '4590',
     district: '51',
     name: 'St Catherine',
     location: 'Hopedale',
     diocese: '4',
     division: '5'
  },
  {
     id: '4603',
     district: '37',
     name: 'Perpetual Help',
     location: 'Grove City',
     diocese: '3',
     division: '1'
  },
  {
     id: '4617',
     district: '54',
     name: 'St John of Beverly',
     location: 'Beverly',
     diocese: '4',
     division: '1'
  },
  {
     id: '4658',
     district: '83',
     name: 'Fr Michael Coan',
     location: 'McDonald',
     diocese: '6',
     division: '5'
  },
  {
     id: '4664',
     district: '19',
     name: 'Charles Reymann',
     location: 'Akron',
     diocese: '2',
     division: '3'
  },
  {
     id: '4731',
     district: '21',
     name: 'North Olmsted',
     location: 'North Olmsted',
     diocese: '2',
     division: '2'
  },
  {
     id: '4733',
     district: '74',
     name: 'Holy Martyrs',
     location: 'Canton',
     diocese: '6',
     division: '2'
  },
  {
     id: '4790',
     district: '99',
     name: 'Holy Cross',
     location: 'Holgate',
     diocese: '5',
     division: ''
  },
  {
     id: '4801',
     district: '27',
     name: 'Don Bosco',
     location: 'Mentor',
     diocese: '2',
     division: '3'
  },
  {
     id: '4847',
     district: '24',
     name: 'Brunswick',
     location: 'Brunswick',
     diocese: '2',
     division: '1'
  },
  {
     id: '4891',
     district: '20',
     name: 'Amherst Holy Family',
     location: 'Amherst',
     diocese: '2',
     division: '3'
  },
  {
     id: '4893',
     district: '31',
     name: 'The Valley',
     location: 'Solon',
     diocese: '2',
     division: '3'
  },
  {
     id: '4900',
     district: '29',
     name: 'Vatican',
     location: 'Parma',
     diocese: '2',
     division: ''
  },
  {
     id: '5009',
     district: '53',
     name: 'St Joseph Of Monroe County',
     location: 'Woodsfield',
     diocese: '4',
     division: '4'
  },
  {
     id: '5023',
     district: '65',
     name: 'St Edward',
     location: 'Huron',
     diocese: '5',
     division: '3'
  },
  {
     id: '5063',
     district: '79',
     name: 'Charity',
     location: 'Kinsman',
     diocese: '6',
     division: '5'
  },
  {
     id: '5069',
     district: '28',
     name: 'Colombiere',
     location: 'University Heights',
     diocese: '2',
     division: ''
  },
  {
     id: '5106',
     district: '29',
     name: 'Maple Heights',
     location: 'Maple Heights',
     diocese: '2',
     division: '4'
  },
  {
     id: '5128',
     district: '10',
     name: 'St Malachy',
     location: 'Morrow',
     diocese: '1',
     division: '3'
  },
  {
     id: '5129',
     district: '6',
     name: 'St John',
     location: 'Tipp City',
     diocese: '1',
     division: '2'
  },
  {
     id: '5139',
     district: '61',
     name: 'Holy Cross',
     location: 'Rossford',
     diocese: '5',
     division: '4'
  },
  {
     id: '5173',
     district: '75',
     name: 'St Peters',
     location: 'Rootstown',
     diocese: '6',
     division: '5'
  },
  {
     id: '5174',
     district: '52',
     name: 'Shadyside St Marys',
     location: 'Shadyside',
     diocese: '4',
     division: ''
  },
  {
     id: '5226',
     district: '56',
     name: 'Sacred Heart',
     location: 'Montpelier',
     diocese: '5',
     division: '5'
  },
  {
     id: '5239',
     district: '2',
     name: 'Msgr Kuenie',
     location: 'Mccartyvl-St Patrk',
     diocese: '1',
     division: '1'
  },
  {
     id: '5250',
     district: '55',
     name: 'Our Lady of the Assumption',
     location: 'Barnesville',
     diocese: '4',
     division: '5'
  },
  {
     id: '5253',
     district: '44',
     name: 'Father Andrew H Hohman',
     location: 'Reynoldsburg',
     diocese: '3',
     division: '1'
  },
  {
     id: '5286',
     district: '71',
     name: 'Geneva-Madison',
     location: 'Geneva',
     diocese: '6',
     division: '2'
  },
  {
     id: '5297',
     district: '39',
     name: 'Fr John S Hannan',
     location: 'Circleville',
     diocese: '3',
     division: '3'
  },
  {
     id: '5371',
     district: '84',
     name: 'All Saints',
     location: 'Youngstown',
     diocese: '6',
     division: ''
  },
  {
     id: '5386',
     district: '39',
     name: 'Colman',
     location: 'Washington Ct House',
     diocese: '3',
     division: '4'
  },
  {
     id: '5391',
     district: '28',
     name: 'St Francis Assisi',
     location: 'Warrensville Hts',
     diocese: '2',
     division: ''
  },
  {
     id: '5405',
     district: '27',
     name: 'Wickliffe',
     location: 'Wickliffe',
     diocese: '2',
     division: '2'
  },
  {
     id: '5429',
     district: '37',
     name: 'Pope John XXIII',
     location: 'Columbus',
     diocese: '3',
     division: '3'
  },
  {
     id: '5483',
     district: '47',
     name: 'John F Kennedy',
     location: 'Newcomerstown',
     diocese: '3',
     division: ''
  },
  {
     id: '5506',
     district: '32',
     name: 'John Fitzgerald Kennedy',
     location: 'Orrville',
     diocese: '2',
     division: '5'
  },
  {
     id: '5534',
     district: '45',
     name: 'Marysville',
     location: 'Marysville',
     diocese: '3',
     division: '2'
  },
  {
     id: '5559',
     district: '31',
     name: 'St. Barnabas',
     location: 'Northfield',
     diocese: '2',
     division: '4'
  },
  {
     id: '5582',
     district: '73',
     name: 'Rt Rev Msgr Anthony P Boeff',
     location: 'Navarre',
     diocese: '6',
     division: '2'
  },
  {
     id: '5583',
     district: '99',
     name: 'Pieta',
     location: 'Yorkville',
     diocese: '4',
     division: ''
  },
  {
     id: '5589',
     district: '71',
     name: 'St. Mary/Sacred Heart',
     location: 'Orwell',
     diocese: '6',
     division: '5'
  },
  {
     id: '5613',
     district: '25',
     name: 'Our Lady of Victory',
     location: 'Tallmadge',
     diocese: '2',
     division: '3'
  },
  {
     id: '5621',
     district: '17',
     name: 'La Salle',
     location: 'Cincinnati',
     diocese: '1',
     division: '4'
  },
  {
     id: '5624',
     district: '12',
     name: 'St Martin De Porres',
     location: 'Cincinnati',
     diocese: '1',
     division: '5'
  },
  {
     id: '5628',
     district: '59',
     name: 'Immaculate Conception',
     location: 'Sylvania',
     diocese: '5',
     division: '3'
  },
  {
     id: '5669',
     district: '63',
     name: 'Fr Michael Muehe',
     location: 'Kalida',
     diocese: '5',
     division: '1'
  },
  {
     id: '5674',
     district: '99',
     name: 'Glenmary',
     location: 'Cincinnati',
     diocese: '1',
     division: '4'
  },
  {
     id: '5764',
     district: '18',
     name: 'Father Chaminade',
     location: 'Dayton',
     diocese: '1',
     division: ''
  },
  {
     id: '5776',
     district: '46',
     name: 'Westerville',
     location: 'Westerville',
     diocese: '3',
     division: '1'
  },
  {
     id: '5801',
     district: '44',
     name: 'Saint Jude',
     location: 'Gahanna',
     diocese: '3',
     division: '1'
  },
  {
     id: '5834',
     district: '47',
     name: 'St Thomas More',
     location: 'Columbus',
     diocese: '3',
     division: ''
  },
  {
     id: '5899',
     district: '40',
     name: 'Immaculate Heart',
     location: 'Columbus',
     diocese: '3',
     division: '1'
  },
  {
     id: '6034',
     district: '62',
     name: 'Van Wert',
     location: 'Van Wert',
     diocese: '5',
     division: '2'
  },
  {
     id: '6144',
     district: '5',
     name: 'A J Schulte',
     location: 'New Carlisle',
     diocese: '1',
     division: '3'
  },
  {
     id: '6373',
     district: '61',
     name: 'Holy Trinity',
     location: 'Bowling Green',
     diocese: '5',
     division: '2'
  },
  {
     id: '6426',
     district: '55',
     name: 'St Joseph',
     location: 'Amsterdam',
     diocese: '4',
     division: ''
  },
  {
     id: '7491',
     district: '80',
     name: 'John K Mahaney Champion',
     location: 'Warren',
     diocese: '6',
     division: '4'
  },
  {
     id: '7552',
     district: '57',
     name: 'Archbold',
     location: 'Archbold',
     diocese: '5',
     division: '3'
  },
  {
     id: '7970',
     district: '20',
     name: 'North Ridgeville',
     location: 'North Ridgeville',
     diocese: '2',
     division: '2'
  },
  {
     id: '7978',
     district: '68',
     name: 'Perrysburg',
     location: 'Perrysburg',
     diocese: '5',
     division: '1'
  },
  {
     id: '7981',
     district: '5',
     name: 'Reverend J. Daniel Schuh',
     location: 'Beavercreek',
     diocese: '1',
     division: '2'
  },
  {
     id: '8064',
     district: '18',
     name: 'Lavern H Wabler Sr PSD',
     location: 'Dayton',
     diocese: '1',
     division: ''
  },
  {
     id: '8115',
     district: '11',
     name: 'Father John W Roettele',
     location: 'Fairfield',
     diocese: '1',
     division: '3'
  },
  {
     id: '8320',
     district: '33',
     name: 'John Carroll',
     location: 'University Heights',
     diocese: '2',
     division: '5'
  },
  {
     id: '8357',
     district: '67',
     name: 'Walt Keppler',
     location: 'Lexington',
     diocese: '5',
     division: '4'
  },
  {
     id: '8369',
     district: '20',
     name: 'Father Mitchell S Cieslik',
     location: 'Grafton',
     diocese: '2',
     division: '5'
  },
  {
     id: '8829',
     district: '57',
     name: 'St Caspar',
     location: 'Wauseon',
     diocese: '5',
     division: '3'
  },
  {
     id: '9788',
     district: '63',
     name: 'St Anthony of Padua',
     location: 'Columbus Grove',
     diocese: '5',
     division: '1'
  },
  {
     id: '9804',
     district: '51',
     name: 'Bishop John King Mussio',
     location: 'Steubenville',
     diocese: '4',
     division: '4'
  },
  {
     id: '10003',
     district: '15',
     name: 'Father John J Wenzel S J',
     location: 'Milford',
     diocese: '1',
     division: '2'
  },
  {
     id: '10043',
     district: '56',
     name: 'Hicksville',
     location: 'Hicksville',
     diocese: '5',
     division: '3'
  },
  {
     id: '10063',
     district: '65',
     name: 'Reverend John E Schreiner',
     location: 'New London',
     diocese: '5',
     division: '4'
  },
  {
     id: '10149',
     district: '16',
     name: 'St Mary',
     location: 'Hillsboro',
     diocese: '1',
     division: '4'
  },
  {
     id: '10183',
     district: '78',
     name: 'St Jude',
     location: 'Columbiana',
     diocese: '6',
     division: '4'
  },
  {
     id: '10215',
     district: '8',
     name: 'St Leonard',
     location: 'Centerville',
     diocese: '1',
     division: '2'
  },
  {
     id: '10272',
     district: '11',
     name: 'St Susanna',
     location: 'Mason',
     diocese: '1',
     division: '2'
  },
  {
     id: '10284',
     district: '46',
     name: 'Father Holtzapfel',
     location: 'Columbus',
     diocese: '3',
     division: '5'
  },
  {
     id: '10299',
     district: '60',
     name: 'St Anthony',
     location: 'Milan',
     diocese: '5',
     division: ''
  },
  {
     id: '10749',
     district: '69',
     name: 'Ss Francis Gaspar',
     location: 'New Riegel',
     diocese: '5',
     division: '3'
  },
  {
     id: '10765',
     district: '36',
     name: 'Saint Joan of Arc',
     location: 'Powell',
     diocese: '3',
     division: '2'
  },
  {
     id: '10787',
     district: '28',
     name: 'Emmanuel',
     location: 'Chesterland',
     diocese: '2',
     division: ''
  },
  {
     id: '10792',
     district: '24',
     name: 'St Francis of Assisi',
     location: 'Strongsville',
     diocese: '2',
     division: '2'
  },
  {
     id: '10820',
     district: '41',
     name: 'Father John Kempf',
     location: 'Dresden',
     diocese: '3',
     division: '4'
  },
  {
     id: '10863',
     district: '36',
     name: 'Saint Brigid of Kildare',
     location: 'Dublin',
     diocese: '3',
     division: '1'
  },
  {
     id: '10876',
     district: '43',
     name: 'Saint Edwards',
     location: 'Granville',
     diocese: '3',
     division: '2'
  },
  {
     id: '10936',
     district: '25',
     name: 'Father Maruskin',
     location: 'Stow',
     diocese: '2',
     division: '2'
  },
  {
     id: '10941',
     district: '46',
     name: 'New Albany',
     location: 'New Albany',
     diocese: '3',
     division: '1'
  },
  {
     id: '11037',
     district: '73',
     name: 'Ss Philip & James',
     location: 'Canal Fulton',
     diocese: '6',
     division: '4'
  },
  {
     id: '11150',
     district: '99',
     name: 'St Mary',
     location: 'Oxford',
     diocese: '1',
     division: ''
  },
  {
     id: '11187',
     district: '47',
     name: 'St Elizabeth Ann Seton',
     location: 'Pickerington',
     diocese: '3',
     division: '1'
  },
  {
     id: '11188',
     district: '47',
     name: 'Miraculous Medal',
     location: 'Columbus',
     diocese: '3',
     division: '4'
  },
  {
     id: '11193',
     district: '46',
     name: 'Saint Elizabeth',
     location: 'Columbus',
     diocese: '3',
     division: '4'
  },
  {
     id: '11195',
     district: '52',
     name: 'St Frances Cabrini',
     location: 'Colerain',
     diocese: '4',
     division: '5'
  },
  {
     id: '11207',
     district: '37',
     name: 'Saint Patrick',
     location: 'Columbus',
     diocese: '3',
     division: '2'
  },
  {
     id: '11208',
     district: '35',
     name: 'St Brendan',
     location: 'Hilliard',
     diocese: '3',
     division: '1'
  },
  {
     id: '11216',
     district: '36',
     name: 'St Peter',
     location: 'Columbus',
     diocese: '3',
     division: '2'
  },
  {
     id: '11224',
     district: '35',
     name: 'Father Sheldon Kelly',
     location: 'West Jefferson',
     diocese: '3',
     division: '4'
  },
  {
     id: '11275',
     district: '36',
     name: 'St Andrew',
     location: 'Upper Arlington',
     diocese: '3',
     division: '2'
  },
  {
     id: '11287',
     district: '99',
     name: 'St Aloysius Republic',
     location: 'Republic',
     diocese: '5',
     division: ''
  },
  {
     id: '11311',
     district: '36',
     name: 'St Agatha',
     location: 'Upper Arlington',
     diocese: '3',
     division: '4'
  },
  {
     id: '11354',
     district: '44',
     name: 'Saint Catharine',
     location: 'Bexley',
     diocese: '3',
     division: '2'
  },
  {
     id: '11355',
     district: '11',
     name: 'St Maximilian Kolbe',
     location: 'Liberty Township',
     diocese: '1',
     division: '2'
  },
  {
     id: '11369',
     district: '82',
     name: 'Father Francis X Borrano-Father Jos Gallagher',
     location: 'Canfield',
     diocese: '6',
     division: '4'
  },
  {
     id: '11370',
     district: '58',
     name: 'St Joseph',
     location: 'Maumee',
     diocese: '5',
     division: '2'
  },
  {
     id: '11380',
     district: '50',
     name: 'Saint Gabriel',
     location: 'Minerva',
     diocese: '4',
     division: '5'
  },
  {
     id: '11445',
     district: '42',
     name: 'St Michael',
     location: 'Worthington',
     diocese: '3',
     division: '1'
  },
  {
     id: '11450',
     district: '68',
     name: 'St Jerome',
     location: 'Walbridge',
     diocese: '5',
     division: '4'
  },
  {
     id: '11464',
     district: '24',
     name: 'St Elizabeth Ann Seton',
     location: 'Columbia Station',
     diocese: '2',
     division: '5'
  },
  {
     id: '11550',
     district: '17',
     name: 'St Joseph of the Three Rivers',
     location: 'North Bend',
     diocese: '1',
     division: '1'
  },
  {
     id: '11551',
     district: '78',
     name: 'Saint Paul the Apostle',
     location: 'New Middletown',
     diocese: '6',
     division: '5'
  },
  {
     id: '11626',
     district: '18',
     name: 'St Bartholomew',
     location: 'Cincinnati',
     diocese: '1',
     division: ''
  },
  {
     id: '11646',
     district: '84',
     name: 'St Robert Bellarmine',
     location: 'Cortland',
     diocese: '6',
     division: '5'
  },
  {
     id: '11649',
     district: '18',
     name: 'St Bernard',
     location: 'Taylor\'s Creek',
     diocese: '1',
     division: '5'
  },
  {
     id: '11650',
     district: '18',
     name: 'Rev Robert E Hungling',
     location: 'Cincinnati',
     diocese: '1',
     division: ''
  },
  {
     id: '11665',
     district: '43',
     name: 'Fr Bill Johnson',
     location: 'Newark',
     diocese: '3',
     division: '2'
  },
  {
     id: '11801',
     district: '76',
     name: 'St Ambrose',
     location: 'Garrettsville',
     diocese: '6',
     division: '4'
  },
  {
     id: '11828',
     district: '51',
     name: 'Saint John Neumann',
     location: 'Steubenville',
     diocese: '4',
     division: '3'
  },
  {
     id: '11831',
     district: '31',
     name: 'SS Cosmas and Damian Our Lady of Guadalupe',
     location: 'Twinsburg',
     diocese: '2',
     division: '4'
  },
  {
     id: '11915',
     district: '81',
     name: 'Father Daniel M Venglarik',
     location: 'Boardman',
     diocese: '6',
     division: '3'
  },
  {
     id: '12224',
     district: '64',
     name: 'St Joseph',
     location: 'Marblehead',
     diocese: '5',
     division: '5'
  },
  {
     id: '12310',
     district: '55',
     name: 'Holy Family',
     location: 'Steubenville',
     diocese: '4',
     division: ''
  },
  {
     id: '12359',
     district: '14',
     name: 'Joseph Cardinal Bernardin',
     location: 'Cincinnati',
     diocese: '1',
     division: '2'
  },
  {
     id: '12539',
     district: '84',
     name: 'Bet Moroon',
     location: 'Youngstown',
     diocese: '6',
     division: ''
  },
  {
     id: '12641',
     district: '43',
     name: 'St Leonard',
     location: 'Heath',
     diocese: '3',
     division: '5'
  },
  {
     id: '12756',
     district: '81',
     name: 'Bishop James W Malone',
     location: 'Boardman',
     diocese: '6',
     division: '4'
  },
  {
     id: '12772',
     district: '35',
     name: 'Father Edward Fitzgerald',
     location: 'Plain City',
     diocese: '3',
     division: '2'
  },
  {
     id: '12807',
     district: '60',
     name: 'The Chaplain Father John Duffy',
     location: 'Sandusky',
     diocese: '5',
     division: '5'
  },
  {
     id: '12900',
     district: '40',
     name: 'Victory',
     location: 'Columbus',
     diocese: '3',
     division: '4'
  },
  {
     id: '12912',
     district: '6',
     name: 'Father Aufderheide',
     location: 'Vandalia',
     diocese: '1',
     division: '2'
  },
  {
     id: '12939',
     district: '35',
     name: 'St Margaret of Cortona',
     location: 'Columbus',
     diocese: '3',
     division: '4'
  },
  {
     id: '13081',
     district: '34',
     name: 'Holy Trinity Zoar',
     location: 'Zoar',
     diocese: '3',
     division: '5'
  },
  {
     id: '13260',
     district: '80',
     name: 'Vienna',
     location: 'Vienna',
     diocese: '6',
     division: '4'
  },
  {
     id: '13289',
     district: '84',
     name: 'Walsh University',
     location: 'North Canton',
     diocese: '6',
     division: ''
  },
  {
     id: '13371',
     district: '77',
     name: 'Crossroads',
     location: 'Summitville',
     diocese: '6',
     division: '5'
  },
  {
     id: '13379',
     district: '41',
     name: 'Our Lady of Mount Carmel',
     location: 'Buckeye Lake',
     diocese: '3',
     division: '5'
  },
  {
     id: '13428',
     district: '37',
     name: 'Holy Family',
     location: 'Columbus',
     diocese: '3',
     division: '4'
  },
  {
     id: '13429',
     district: '15',
     name: 'St Margaret of York',
     location: 'Loveland',
     diocese: '1',
     division: '1'
  },
  {
     id: '13466',
     district: '82',
     name: 'Campbell',
     location: 'Campbell',
     diocese: '6',
     division: ''
  },
  {
     id: '13517',
     district: '25',
     name: 'Immaculate Heart of Mary',
     location: 'Cuyahoga Falls',
     diocese: '2',
     division: '2'
  },
  {
     id: '13581',
     district: '40',
     name: 'Father Raymond S Bauschard',
     location: 'Columbus',
     diocese: '3',
     division: '5'
  },
  {
     id: '13586',
     district: '83',
     name: 'St Dominic/Bishop Fenwick',
     location: 'Youngstown',
     diocese: '6',
     division: '4'
  },
  {
     id: '13601',
     district: '29',
     name: 'William H. Ankney',
     location: 'Loudonville',
     diocese: '2',
     division: '5'
  },
  {
     id: '13608',
     district: '12',
     name: 'St John the Evangelist',
     location: 'West Chester',
     diocese: '1',
     division: '2'
  },
  {
     id: '13614',
     district: '47',
     name: 'Nuestra Senora De Guadalupe',
     location: 'Columbus',
     diocese: '3',
     division: ''
  },
  {
     id: '13636',
     district: '58',
     name: 'St Clement\'s-Rev Gary Miller',
     location: 'Toledo',
     diocese: '5',
     division: '5'
  },
  {
     id: '13640',
     district: '28',
     name: 'Sagrada Familia/San Miguel',
     location: 'Cleveland',
     diocese: '2',
     division: '5'
  },
  {
     id: '13705',
     district: '47',
     name: 'Christ the King',
     location: 'Columbus',
     diocese: '3',
     division: '5'
  },
  {
     id: '13755',
     district: '27',
     name: 'St Bede The Venerable',
     location: 'Mentor',
     diocese: '2',
     division: '4'
  },
  {
     id: '13813',
     district: '15',
     name: 'St Columban',
     location: 'Loveland',
     diocese: '1',
     division: '1'
  },
  {
     id: '13844',
     district: '29',
     name: 'Saint Vincent de Paul',
     location: 'Elyria',
     diocese: '2',
     division: ''
  },
  {
     id: '13874',
     district: '7',
     name: 'Saint Paul',
     location: 'Englewood',
     diocese: '1',
     division: '5'
  },
  {
     id: '13977',
     district: '82',
     name: 'Saint Joseph-Austintown',
     location: 'Austintown',
     diocese: '6',
     division: '4'
  },
  {
     id: '13984',
     district: '21',
     name: 'Brook Park',
     location: 'Brook Park',
     diocese: '2',
     division: '3'
  },
  {
     id: '14054',
     district: '30',
     name: 'St Vincent',
     location: 'Akron',
     diocese: '2',
     division: '4'
  },
  {
     id: '14092',
     district: '16',
     name: 'St Benignus',
     location: 'Greenfield',
     diocese: '1',
     division: '5'
  },
  {
     id: '14093',
     district: '99',
     name: 'St Anthony',
     location: 'Columbus',
     diocese: '3',
     division: '5'
  },
  {
     id: '14094',
     district: '11',
     name: 'St Aloysius-Shandon',
     location: 'Shandon',
     diocese: '1',
     division: '5'
  },
  {
     id: '14111',
     district: '19',
     name: 'Prince of Peace',
     location: 'Norton',
     diocese: '2',
     division: '4'
  },
  {
     id: '14155',
     district: '58',
     name: 'St Patrick of Heatherdowns',
     location: 'Toledo',
     diocese: '5',
     division: '3'
  },
  {
     id: '14186',
     district: '76',
     name: 'Our Lady of Perpetual Help of Aurora',
     location: 'Aurora',
     diocese: '6',
     division: '3'
  },
  {
     id: '14255',
     district: '30',
     name: 'St Sebastian',
     location: 'Akron',
     diocese: '2',
     division: '3'
  },
  {
     id: '14282',
     district: '42',
     name: 'Our Lady of Peace',
     location: 'Columbus',
     diocese: '3',
     division: '4'
  },
  {
     id: '14342',
     district: '40',
     name: 'St Christopher',
     location: 'Columbus',
     diocese: '3',
     division: '5'
  },
  {
     id: '14344',
     district: '61',
     name: 'River East - Mother Teresa',
     location: 'Toledo',
     diocese: '5',
     division: '3'
  },
  {
     id: '14345',
     district: '40',
     name: 'St Timothy',
     location: 'Columbus',
     diocese: '3',
     division: '5'
  },
  {
     id: '14346',
     district: '38',
     name: 'Pope John Paul II',
     location: 'Wheelersburg',
     diocese: '3',
     division: '4'
  },
  {
     id: '14400',
     district: '9',
     name: 'Father Charles E Mentrup',
     location: 'Franklin',
     diocese: '1',
     division: '2'
  },
  {
     id: '14406',
     district: '26',
     name: 'Our Lady Of Charity',
     location: 'Broadview Heights',
     diocese: '2',
     division: '3'
  },
  {
     id: '14408',
     district: '10',
     name: 'St Francis De Sales',
     location: 'Lebanon',
     diocese: '1',
     division: '4'
  },
  {
     id: '14416',
     district: '21',
     name: 'St Mary of The Falls',
     location: 'Olmsted Falls',
     diocese: '2',
     division: '2'
  },
  {
     id: '14457',
     district: '42',
     name: 'Saint John Neumann',
     location: 'Sunbury',
     diocese: '3',
     division: '1'
  },
  {
     id: '14491',
     district: '84',
     name: 'St James',
     location: 'Waynesburg',
     diocese: '6',
     division: ''
  },
  {
     id: '14502',
     district: '61',
     name: 'St. John XXIII',
     location: 'Perrysburg',
     diocese: '5',
     division: '1'
  },
  {
     id: '14504',
     district: '8',
     name: 'Father Francis X Hoffer O.F.M.',
     location: 'Centerville',
     diocese: '1',
     division: '2'
  },
  {
     id: '14545',
     district: '17',
     name: 'St Lawrence-Price Hill',
     location: 'Cincinnati',
     diocese: '1',
     division: '5'
  },
  {
     id: '14551',
     district: '30',
     name: 'St Hilary',
     location: 'Akron',
     diocese: '2',
     division: '1'
  },
  {
     id: '14563',
     district: '10',
     name: 'Our Lady of Sorrows',
     location: 'Monroe',
     diocese: '1',
     division: '5'
  },
  {
     id: '14603',
     district: '99',
     name: 'St Therese Little Flower',
     location: 'Brewster',
     diocese: '6',
     division: ''
  },
  {
     id: '14665',
     district: '12',
     name: 'Queen of Apostles',
     location: 'Cincinnati',
     diocese: '1',
     division: '2'
  },
  {
     id: '14671',
     district: '45',
     name: 'Sacred Hearts',
     location: 'Cardington',
     diocese: '3',
     division: '5'
  },
  {
     id: '14714',
     district: '23',
     name: 'St Cyprian',
     location: 'Perry',
     diocese: '2',
     division: '4'
  },
  {
     id: '14769',
     district: '24',
     name: 'St Martin Of Tours',
     location: 'Valley City',
     diocese: '2',
     division: '4'
  },
  {
     id: '14834',
     district: '14',
     name: 'Salve Regina',
     location: 'Cincinnati',
     diocese: '1',
     division: '3'
  },
  {
     id: '14882',
     district: '9',
     name: 'Fr Martin T Gilligan',
     location: 'Dayton',
     diocese: '1',
     division: '3'
  },
  {
     id: '14891',
     district: '8',
     name: 'Our Lady of the Light',
     location: 'Kettering',
     diocese: '1',
     division: '3'
  },
  {
     id: '14959',
     district: '72',
     name: 'Holy Spirit',
     location: 'Uniontown',
     diocese: '6',
     division: '5'
  },
  {
     id: '14962',
     district: '42',
     name: 'Immaculate Conception',
     location: 'Columbus',
     diocese: '3',
     division: '3'
  },
  {
     id: '14995',
     district: '8',
     name: 'Monsignor Lawrence K Breslin',
     location: 'Kettering',
     diocese: '1',
     division: '1'
  },
  {
     id: '15009',
     district: '42',
     name: 'Pontifical College Josephinum',
     location: 'Columbus',
     diocese: '3',
     division: '3'
  },
  {
     id: '15023',
     district: '33',
     name: 'Sacred Heart Of Jesus',
     location: 'South Euclid',
     diocese: '2',
     division: '5'
  },
  {
     id: '15036',
     district: '64',
     name: 'Los Caballeros De Sandusky County',
     location: 'Fremont',
     diocese: '5',
     division: '5'
  },
  {
     id: '15043',
     district: '59',
     name: 'Holy Trinity',
     location: 'Assumption',
     diocese: '5',
     division: '4'
  },
  {
     id: '15056',
     district: '26',
     name: 'Holy Family Parma',
     location: 'Parma',
     diocese: '2',
     division: '4'
  },
  {
     id: '15086',
     district: '99',
     name: 'Immacolata',
     location: 'Youngstown',
     diocese: '6',
     division: '4'
  },
  {
     id: '15312',
     district: '75',
     name: 'Newman Center At Kent State University',
     location: 'Kent State University',
     diocese: '6',
     division: '5'
  },
  {
     id: '15330',
     district: '10',
     name: 'Holy Name of Jesus',
     location: 'Trenton',
     diocese: '1',
     division: '5'
  },
  {
     id: '15401',
     district: '50',
     name: 'Our Lady of Carroll County',
     location: 'Carrollton',
     diocese: '4',
     division: '5'
  },
  {
     id: '15424',
     district: '6',
     name: 'Monsignor Robert J Von Kaenel',
     location: 'Covington',
     diocese: '1',
     division: '5'
  },
  {
     id: '15447',
     district: '39',
     name: 'St Mark',
     location: 'Lancaster',
     diocese: '3',
     division: '4'
  },
  {
     id: '15458',
     district: '73',
     name: 'St Michael The Archangel',
     location: 'Canton',
     diocese: '6',
     division: '3'
  },
  {
     id: '15533',
     district: '17',
     name: 'St Dominic-Delhi',
     location: 'Cincinnati',
     diocese: '1',
     division: '4'
  },
  {
     id: '15569',
     district: '54',
     name: 'Saint Ambrose',
     location: 'Little Hocking',
     diocese: '4',
     division: '5'
  },
  {
     id: '15573',
     district: '81',
     name: 'Holy Family',
     location: 'Poland',
     diocese: '6',
     division: '3'
  },
  {
     id: '15614',
     district: '26',
     name: 'St Anthony of Padua-Parma',
     location: 'Parma',
     diocese: '2',
     division: '4'
  },
  {
     id: '15645',
     district: '7',
     name: 'Holy Angels',
     location: 'Dayton',
     diocese: '1',
     division: '5'
  },
  {
     id: '15737',
     district: '33',
     name: 'St John of the Cross',
     location: 'Euclid',
     diocese: '2',
     division: '5'
  },
  {
     id: '15793',
     district: '38',
     name: 'Fr Charles Griffin',
     location: 'Chillicothe',
     diocese: '3',
     division: '4'
  },
  {
     id: '15824',
     district: '41',
     name: 'Angelic Warriors',
     location: 'Zanesville',
     diocese: '3',
     division: '4'
  },
  {
     id: '15901',
     district: '21',
     name: 'St Adalbert',
     location: 'Berea',
     diocese: '2',
     division: '5'
  },
  {
     id: '15905',
     district: '59',
     name: 'Saint Joan of Arc',
     location: 'Toledo',
     diocese: '5',
     division: '2'
  },
  {
     id: '15942',
     district: '23',
     name: 'St Mary Of Chardon',
     location: 'Chardon',
     diocese: '2',
     division: '3'
  },
  {
     id: '15959',
     district: '83',
     name: 'St Edward',
     location: 'Youngstown',
     diocese: '6',
     division: '5'
  },
  {
     id: '16137',
     district: '26',
     name: 'St Charles Borromeo',
     location: 'Parma',
     diocese: '2',
     division: '4'
  },
  {
     id: '16164',
     district: '14',
     name: 'Mount St Mary\'s Seminary Of The West',
     location: 'Cincinnati',
     diocese: '1',
     division: '4'
  },
  {
     id: '16264',
     district: '68',
     name: 'Our Lady Queen Of The Most Holy Rosary',
     location: 'Toledo',
     diocese: '5',
     division: '5'
  },
  {
     id: '16279',
     district: '26',
     name: 'Mary Queen of Peace',
     location: 'Cleveland',
     diocese: '2',
     division: '4'
  },
  {
     id: '16348',
     district: '16',
     name: 'St. Isidore',
     location: 'West Union',
     diocese: '1',
     division: '5'
  },
  {
     id: '16373',
     district: '21',
     name: 'St. Ladislas',
     location: 'Westlake',
     diocese: '2',
     division: '3'
  },
  {
     id: '16376',
     district: '21',
     name: 'St. Bernadette',
     location: 'Westlake',
     diocese: '2',
     division: '3'
  },
  {
     id: '16425',
     district: '18',
     name: 'Wright State University',
     location: 'Fairborn',
     diocese: '1',
     division: '5'
  },
  {
     id: '16461',
     district: '13',
     name: 'Mother of Mercy',
     location: 'New Burlington',
     diocese: '1',
     division: '5'
  },
  {
     id: '16561',
     district: '44',
     name: 'St. Angelo Giuseppe Roncalli',
     location: 'Canal Winchester',
     diocese: '3',
     division: '4'
  },
  {
     id: '16571',
     district: '7',
     name: 'La Morenita de Guadalupe',
     location: 'Dayton',
     diocese: '1',
     division: '5'
  },
  {
     id: '16706',
     district: '13',
     name: 'St. John the Baptist Dry Ridge',
     location: 'Cincinnati',
     diocese: '1',
     division: '5'
  },
  {
     id: '16884',
     district: '18',
     name: 'San Carlos Borromeo',
     location: 'Cincinnati',
     diocese: '1',
     division: '5'
  },
  {
     id: '17092',
     district: '9',
     name: 'Father Joseph Lutmer',
     location: 'Waynesville',
     diocese: '1',
     division: '5'
  },
  {
     id: '17113',
     district: '61',
     name: 'Sts. Patrick & Louis',
     location: 'Grand Rapids',
     diocese: '5',
     division: '5'
  },
  {
     id: '17398',
     district: '79',
     name: 'St. Sebastian Martyr',
     location: 'Warren',
     diocese: '6',
     division: '5'
  },
  {
     id: '17425',
     district: '47',
     name: 'San Santiago el Menor',
     location: 'Columbus',
     diocese: '3',
     division: '5'
  },
  {
     id: '17654',
     district: '62',
     name: 'St. Martin de Porres',
     location: 'Lima',
     diocese: '5',
     division: '2'
  },
  {
     id: '17793',
     district: '4',
     name: 'Padre Miguel Pro',
     location: 'Springfield',
     diocese: '1',
     division: '5'
  },
  {
     id: '18047',
     district: '66',
     name: 'San Francisco Javier',
     location: 'Willard',
     diocese: '5',
     division: '5'
  },
  {
     id: '18195',
     district: '36',
     name: 'San Pedro',
     location: 'Columbus',
     diocese: '3',
     division: '5'
  },
  {
     id: '18217',
     district: '5',
     name: 'Sagrado Corazon',
     location: 'Cincinnati',
     diocese: '1',
     division: '5'
  },
  {
     id: '18322',
     district: '7',
     name: 'Seat of Wisdom',
     location: 'Cincinnati',
     diocese: '1',
     division: '5'
  },
  {
     id: '18527',
     district: '22',
     name: 'St. Elias Melkite',
     location: 'Cleveland',
     diocese: '2',
     division: '5'
  },
  {
     id: '18565',
     district: '22',
     name: 'Saint Elizabeth of Hungary',
     location: 'Cleveland',
     diocese: '2',
     division: '5'
  }]
};

export interface Council {
  id: string;
  name: string;
  district: string;
  location: string;
  diocese: string;
  division: string;
}

export class CouncilData {
  static councils: Council[] = councilData[environment.fraternalYear];
}
